import React__default from 'react';
import { ExpressPaymentMethod } from '@grandvisionhq/payments';
import { useIntl } from '@grandvisionhq/state';

const useExpressCheckoutLabels = ()=>{
    const { getLabel  } = useIntl();
    const getTitle = React__default.useCallback((type)=>{
        switch(type){
            case ExpressPaymentMethod.APPLE_PAY:
                return getLabel('checkout.express.apple.pay.header.title');
            default:
                return `Checkout with ${type}`;
        }
    }, [
        getLabel
    ]);
    return {
        getTitle
    };
};

export { useExpressCheckoutLabels };
//# sourceMappingURL=use-express-checkout-labels.js.map
